import { useCallback } from 'react';
import {
  HEADER_CTA_CLICKED,
  headerCtaClickedEventProperties,
} from '@/shared/features/analytics/utils/headerCtaClicked';
import { useAnalytics } from '@/shared/features/analytics/presentation/hooks/useAnalytics';

/** Fires `Header CTA Clicked` (desktop header utilities only). */
export function useTrackHeaderCtaClick() {
  const { analytics, isInitialized } = useAnalytics();

  return useCallback(
    (buttonName: string) => {
      if (!analytics || !isInitialized) return;
      try {
        analytics.trackEvent(HEADER_CTA_CLICKED, headerCtaClickedEventProperties(buttonName));
      } catch (err) {
        console.error('Error tracking Header CTA Clicked:', err);
      }
    },
    [analytics, isInitialized],
  );
}
